export enum OrderbookSymbolsKeyEnum {
  SIDE_WIDGET_ORDERBOOK_SUMMARY = 'sideWidgetOrderbookSummary',
  COMPANY_STREAM_ORDERBOOK = 'companyStreamOrderbook',
  ORDERBOOK = 'orderbook',
  SECURITIES_TRANSACTION = 'securitiesTransaction',
  FAST_ORDER = 'fastOrder',
}

export type OrderbookState = {
  symbols: { [key in OrderbookSymbolsKeyEnum]?: string[] };
};

export type OrderbookActions = {
  setOrderbookSymbols: (key: OrderbookSymbolsKeyEnum, value: string[]) => void;
};

export type OrderbookStore = OrderbookState & OrderbookActions;
